<h1 mat-dialog-title>
    Vincular Condutor
</h1>

<button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
</button>

<mat-horizontal-stepper [linear]="true" #stepper>
    <mat-step [completed]="!formVeiculo.isInvalid">
        <ng-template matStepLabel>Dados do Veículo</ng-template>
        <app-form [campos]="camposDadosVeiculo" appearance="outline" #formVeiculo></app-form>
    </mat-step>

    <mat-step [completed]="!formCondutor.isEmpty">
        <ng-template matStepLabel>Listagem de Condutores</ng-template>
        <app-form [campos]="camposListagemCondutores" appearance="outline" #formListagemCondutores></app-form>
    </mat-step>

    <mat-step [completed]="formCondutor.isValid">
      <ng-template matStepLabel>Dados Pessoais</ng-template>
      <app-form [campos]="camposDadosPessoa" appearance="outline" #formCondutor></app-form>
    </mat-step>
  
    <mat-step [completed]="formCNH.isValid">
      <ng-template matStepLabel>Dados CNH</ng-template>
      <app-form [campos]="camposDadosCNH" appearance="outline" #formCNH></app-form>
    </mat-step>
</mat-horizontal-stepper>


<div mat-dialog-actions align="end">
    <app-ellipsis-animation class="loading" *ngIf="loading" />

    <button 
      type="button" 
      mat-flat-button 
      (click)="stepper.previous()" 
      *ngIf="stepper.selectedIndex !== 0">
        Anterior
    </button>

    <button 
      type="button" 
      mat-flat-button 
      [disabled]="!stepper.selected?.completed" 
      (click)="stepper.next()"
      *ngIf="stepper.selectedIndex < stepper.steps.length -1">
        Próximo
    </button>

    <button 
      type="submit" 
      mat-flat-button 
      [disabled]="!isFormValid" 
      (click)="onSubmit()"
      *ngIf="stepper.selectedIndex === stepper.steps.length -1">
        Vincular condutor
    </button>
</div>